<template>
  <div class="tutorial-modal">
    <WebeoModal
      width="45rem"
      :open="showTutorial"
    >
      <h4 class="get-started-title">
        {{ $t('tutorialPopup.title') }}
      </h4>
      <div class="tile-container">
        <router-link
          class="link-container"
          :to="{ path: '/Campaigns/Create/Details' }"
          @click.native="closeModal()"
          @mouseover.native="campaignHover = true"
          @mouseleave.native="campaignHover = false"
        >
          <div class="tile">
            <img
              v-if="campaignHover"
              title="Create a campaign"
              :src="getCampaignIcon"
            >
            <img
              v-else
              title="Create a campaign"
              :src="getCampaignIcon"
            >
            <span class="icon-title">
              {{ $t('tutorialPopup.createCampaignTile.title') }}
            </span>
            <p>{{ $t('tutorialPopup.createCampaignTile.text') }}</p>
          </div>
          <div class="background" />
        </router-link>

        <div
          class="link-container"
          @click="initiateGainsightWalkthrough()"
          @mouseover="welcomeHover = true"
          @mouseleave="welcomeHover = false"
        >
          <div class="tile">
            <img
              v-if="welcomeHover"
              title="Explore Webeo"
              :src="getWelcomeIcon"
            >
            <img
              v-else
              title="Explore Webeo"
              :src="getWelcomeIcon"
            >
            <span class="icon-title">
              {{ $t('tutorialPopup.exploreTile.title') }}
            </span>
            <p>{{ $t('tutorialPopup.exploreTile.text') }}</p>
          </div>
          <div class="background" />
        </div>
      </div>
      <div class="skip-container">
        <span
          class="skip-text"
          @click="closeModal()"
        >
          {{ $t('tutorialPopup.skipLink') }}
        </span>
      </div>
    </WebeoModal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import config from '../setup/config';

export default {
  data: () => ({
    config,
    campaignHover: false,
    welcomeHover: false,
  }),
  computed: {
    ...mapGetters(['showTutorial']),
    getCampaignIcon() {
      if (this.campaignHover) return `${this.config.microservices.webcontent}/images/dashboard-icons/campaigns_icon_white.svg`;
      return `${this.config.microservices.webcontent}/images/dashboard-icons/campaigns_icon.svg`;
    },
    getWelcomeIcon() {
      if (this.welcomeHover) return `${this.config.microservices.webcontent}/images/dashboard-icons/welcome_icon_white.svg`;
      return `${this.config.microservices.webcontent}/images/dashboard-icons/welcome_icon.svg`;
    },
  },
  methods: {
    ...mapActions(['updateShowUserTutorial', 'updateClientUserShowTutorial']),
    initiateGainsightWalkthrough() {
      /* INITIALISE GAINSIGHT HERE */
      this.closeModal();
    },
    closeModal() {
      this.updateShowUserTutorial(false);

      this.campaignHover = false;
      this.welcomeHover = false;

      this.updateClientUserShowTutorial(false);
    },
  },
};
</script>

<style scoped>
h3 {
  font-size: 22px;
  text-align: center;
  color: var(--webeo-purple);
  font-weight: bold;
  margin: 0;
}
h4 {
  font-size: 20px;
  color: var(--webeo-purple);
  text-align: center;
}
.tile-container {
  display: flex;
  flex-direction: row;
  fill: var(--webeo-purple400);
  stroke-width: 1px;
  stroke-linejoin: round;
  stroke-miterlimit: 11;
}
.link-container {
  text-decoration: none;
  position: relative;
  background-color: white;
  border-radius: 18px;
  height: 250px;
  width: 50%;
  margin: 0px 30px 10px 30px;
  cursor: pointer;
}
.tile {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  padding: 25px 15px;
  height: 100%;
  background-color: transparent;
  border: solid 2px var(--webeo-grey100);
  border-radius: 16px;
  transition: color 0.1s;
  font-size: 1.5rem;
  color: var(--webeo-purple);
  text-align: center;
  border: solid 2px var(--webeo-grey100);
}
.background {
  position: absolute;
  z-index: 1;
  box-sizing: content-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(to bottom right, var(--webeo-magenta), var(--webeo-purple));
  border-radius: 16px;
  transition: 0.3s opacity;
  opacity: 0;
}
.link-container:hover .background{
  opacity: 0.8;
}
.tile:hover {
  border-color: transparent;
  color: white;
}
.tile:hover .background {
  opacity: 1;
}
.tile p {
  color: var(--webeo-black);
  padding: 0;
  margin: 10px 0 0 0;
  font-size: 14px;
}
.link-container:hover p {
  color: white;
}
.tile img {
  height: 80px;
  display: block;
  margin: 0 auto;
  margin-bottom: 12px;
  position: relative;
}

.skip-text {
  text-transform: uppercase;
  color: var(--webeo-cyan);
  float: right;
}

.skip-text:hover {
  cursor: pointer;
}

.skip-container {
  margin-top: 20px;
}
.get-started-title {
  text-align: left;
  margin-top: 0px;
  margin-bottom: 50px;
  color: var(--webeo-slate600);
}
.get-started-title {
  margin-top: 0;
  margin-bottom: 30px;
  color: var(--webeo-purple);
  font-weight: bold;
  text-align: center;
  font-size: 22px;
}
</style>

<style>
.tutorial-modal .webeo-modal-container {
  padding: 2rem;
  position: relative;
  border-radius: 8px!important;
}
</style>
